import React from 'react';
import './Footer.css';
import footerImg from '../../images/logo/logo.png';
import creditCard1 from '../../images/creditCard/creditcard-logo (1).png'

const Footer = () => {
    return (
        <div>
            <div className="footer-container mt-5 pt-5">
                <div className="footer-title"><p>ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.ipsum dolor sit amet, consectetur</p>
                <img style={{width:'200px'}} src={footerImg} alt="" />
                </div>
                <div className="about-title">
                    <h4 className="text-white">About Us</h4>
                    <p>Why UsWhy Touring Reviews Travel Insurance Programme</p>
                </div>
                <div className="support-title">
                    <h4 className="text-white">Support</h4>
                    <p>Account Client Area Privacy & Policy Author Hangout</p>
                </div>
                <div className="pay-title">
                    <h4 className="text-white">Pay Safely</h4>
                    <p>Eiusmod tempor incididunt utbor etian dolm magna aliqua enim minim</p>
                    <img src={creditCard1} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Footer;